/**
 * en-GB messages added by Phase 4 task S47B (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s47bEnGB = {
    'integrations.error.entra_unavailable': 'Microsoft 365 is not set up on this CloudSign installation yet.',
    'integrations.error.entra_not_connected': 'Connect Microsoft 365 first.',
    'integrations.error.entra_group_lookup_failed': 'Microsoft could not be reached to look up groups. Try again in a minute.',
    'integrations.error.entra_mapping_exists': 'That Microsoft group is already mapped.',
    'integrations.error.entra_group_not_repeat': 'Choose a group for repeat visitors or staff.',
    'integrations.error.entra_sync_running': 'A sync is already running.',
    'entra.skip.no_email': 'People without an email address',
    'entra.skip.disabled': 'Disabled accounts',
    'entra.skip.no_name': 'People without a name',
    'entra.problem.group_not_found': 'A mapped Microsoft group could not be read',
    'entra.problem.graph_failed': 'Microsoft could not be reached',
    'entra.problem.not_connected': 'Microsoft 365 is not connected',
    'entra.problem.archive_stopped': 'Archiving stopped because too many people would have been archived',
    'entra.problem.member_failed': 'Some people could not be saved',
    'entra.problem.interrupted': 'The sync did not finish',
    'email.integrations.entra_failed.subject': 'Microsoft 365 sync problem for {tenant}',
    'email.integrations.entra_failed.body': '{tenant}: the last Microsoft 365 sync did not complete properly. Open the Integrations page to see what went wrong. Your existing people have not been removed.',
    'email.integrations.entra_failed.button': 'Open the Integrations page',
    'email.integrations.entra_stopped.subject': 'Microsoft 365 sync stopped for {tenant}',
    'email.integrations.entra_stopped.body': '{tenant}: the Microsoft 365 sync stopped without archiving anyone, because it would have archived more people than your safety limit allows. This usually means a Microsoft group was emptied or renamed. Check the group, then run the sync again.',
    'email.integrations.entra_stopped.button': 'Open the Integrations page',
};
//# sourceMappingURL=s47b.js.map